var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-4",attrs:{"id":"suppliers"}},[_c('supplier-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }